// typings
import { DefaultSymbolInfo } from './typings';

export const DEFAULT_SYMBOL_INFO: DefaultSymbolInfo = {
  timezone: 'Asia/Kolkata',
  data_status: 'streaming',
  type: 'stock',
  format: 'price',
  has_weekly_and_monthly: false,
  has_intraday: true,
  minmove2: 0,
};

export const DEBOUNCE_SEARCH_TIME = 300;

export const SearchSegment = {
  ALL: 'EQ,FO,CURR,COMM,INDEX',
  CASH: 'EQ',
  FUTOPT: 'FO',
  CURRENCY: 'CURR',
  COMMODITY: 'COMM',
};
